import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const ContractManagementApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.CONTRACT_MANAGEMENT}
        scope='contract_management_app'
        envKey={apps[AppId.CONTRACT_MANAGEMENT].runtimeEnvKey}
        entryPath='./ContractManagementApp'
        url={process.env.REACT_APP_CONTRACT_MANAGEMENT_APP_DEV_PATH}
        appName={apps[AppId.CONTRACT_MANAGEMENT].name}
        appProps={{
          user,
          initialPath: apps[AppId.CONTRACT_MANAGEMENT].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { ContractManagementApp }
